export const ARTICLE_TIMEOUT_MS = 15_000;

// Settle the UI at the deadline even if a transport ignores its abort signal.
export function startArticleRequest(load, id, timeoutMs = ARTICLE_TIMEOUT_MS) {
  const controller = new AbortController();
  let timer;
  let rejectAbort;
  const aborted = new Promise((_, reject) => { rejectAbort = reject; });
  const cancel = (reason = new DOMException('Request cancelled', 'AbortError')) => {
    clearTimeout(timer);
    rejectAbort(reason);
    controller.abort();
  };
  timer = setTimeout(() => cancel(new DOMException('Article request timed out', 'TimeoutError')), timeoutMs);
  const promise = Promise.race([
    Promise.resolve().then(() => load(id, { signal: controller.signal })),
    aborted,
  ]).finally(() => clearTimeout(timer));
  return { promise, cancel };
}
